module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._l((_vm.logos), function(logo, index) {
    return _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentLogo === index),
        expression: "currentLogo === index"
      }],
      staticClass: "logoAnimation",
      attrs: {
        "width": "580",
        "height": "227",
        "src": logo
      }
    })
  }), _vm._v(" "), _c('img', {
    staticClass: "logoMobile",
    attrs: {
      "width": "180",
      "height": "43",
      "src": require("./logos/Mobile.svg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("The Longest Shortest Time")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f4375b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Logo.vue
// module id = 796
// module chunks = 1